module.exports = __webpack_public_path__ + "static/media/it-department-website_SK.c35386ce.md";